import Vue from 'vue';
import GlobalOverlay from './index.vue';

const OverlayConstructor = Vue.extend(GlobalOverlay);

let instance;

const OverlayPlugin = {
  install(Vue) {
    if (!instance) {
      instance = new OverlayConstructor();
      document.body.appendChild(instance.$mount().$el);
    }

    Vue.prototype.$overlay = {
      show(message) {
        instance.show(message);
      },
      hide() {
        instance.hide();
      }
    };
  }
};

export default OverlayPlugin;
